import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';

@Component({
  templateUrl: './find-privacy.html',
  styleUrls: ['./find-privacy.scss'],
})

export class FindPrivacyPage {
  /**
   * 사용자 이름
   */
  userName: string = '';

  /**
   * 사용자 아이디
   */
  userId: string = '';

  /**
   * 사용자 핸드폰번호
   */
  userPhoneNum: string = '';

  /**
   * 사용자 핸드폰번호 & 이메일
   */
  userPhoneEmail: string = '';

  /**
   * @constructor
   */
  constructor(
    private $modal: ModalService,
    private $router: Router,
    private $authService: AuthenticationService) {}

  private $showModal(title:string, content: string) {
    this.$modal.open({ title, content });
  }
  /**
   * id 찾기
   */
  onSubmitId() {
    if (this.userName === '' || this.userPhoneEmail === '') {
      this.$showModal('빈칸 입력', '빈칸을 입력해주세요.');
      return;
    }

    this.$authService.findId(this.userName, this.userPhoneEmail).subscribe(
      (data) => {
        const id = data && Array.isArray(data) && data[0] && data[0].bm_id;
        this.$router.navigate([`/find-id/${id}/${this.userName}`]);
      },
      (err) => {
        console.log('Find id error', err);
        this.$showModal('입력 오류', '정보를 올바르게 입력해주세요.');
      });
  }

  /**
   * pw 찾기
   */
  onSubmitPw() {
    if (this.userName === '' || this.userId === '' || this.userPhoneNum === '') {
      this.$showModal('빈칸 입력', '빈칸을 입력해주세요.');
      return;
    }

    this.$authService.findPw(this.userName, this.userId, this.userPhoneNum).
      subscribe(
        () => {
          this.$router.navigate(['/find-pwd']);
        },
        (err) => {
          console.log('Find pwd error', err);
          this.$showModal('입력 오류', '정보를 올바르게 입력해주세요.');
        });
  }
}
